export default {
    data() {
        let touchResolver

        const loadPromise = new Promise(resolve => {
            touchResolver = resolve
        })

        return {
            touchResolver,
            touchHammer: loadPromise,
        }
    },

    methods: {
        async touchInitialize() {
            const Hammer = (await import('hammerjs')).default

            const hammer = new Hammer(this.$el)

            this.touchResolver(hammer)
        },

        async touchBind(event, callback) {
            const hammer = await this.touchHammer

            hammer.on(event, callback)
        },

        touchBindSwipeRight(callback) {
            this.touchBind('swiperight', callback)
        },

        touchBindSwipeLeft(callback) {
            this.touchBind('swipeleft', callback)
        },
    },

    async beforeDestroy() {
        const hammer = await this.touchHammer

        hammer.destroy()
    },
}
